import React from 'react'
import { Typography, Box } from '@material-ui/core'

interface UploadQueriesStepItemProps {
  title: React.ReactNode
  subTitle: React.ReactNode
  stepComponent?: React.ReactNode
}

const UploadQueriesStepItem: React.FC<UploadQueriesStepItemProps> = ({
  title,
  subTitle,
  stepComponent,
}) => {
  return (
    <Box>
      <Typography variant="h2">{title}</Typography>
      <Box mt={2}>
        <Typography variant="body1" component="label">
          {subTitle}
        </Typography>
      </Box>
      {stepComponent ? <Box mt={4}>{stepComponent}</Box> : null}
    </Box>
  )
}

export default UploadQueriesStepItem
